/* global axios */
import ApiClient from './ApiClient';

class Documents extends ApiClient {
  constructor() {
    super('sources/documents', { accountScoped: true });
  }

  get(page, perPage, sortBy, sortOrder) {
    const requestURL = `${this.url}?page=${page}&per_page=${perPage}&sort_by=${sortBy}&sort_order=${sortOrder}`;
    return axios.get(requestURL);
  }

  download(id) {
    const requestURL = `${this.url}/${id}/download`;
    return axios({
      url: requestURL,
      method: 'GET',
      responseType: 'blob',
    });
  }
}

export default new Documents();
